module.exports = __webpack_public_path__ + "static/media/icon-de.5e23d421.svg";